module.exports = __webpack_public_path__ + "img/WHORE.0ad7d54e.jpg";